import { isOrderUnconfirmed, ORDER_STATUS, SERVICE_TYPES } from '@bagonboard/wiseman';
import withStyles from '@material-ui/core/styles/withStyles';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

import { useOrder } from '#views/Dashboard/hooks';
import {
  ButtonConfirmed, Container, IconAlert, OrderStatus, Text,
} from './style';

const { AWAITING } = ORDER_STATUS;
export function TopContainer({
  orderStatus,
  orderId,
  classes,
  services,
}) {
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [resendEmailDialog, setResendEmailDialog] = useState(false);
  const { events, handlers: orderHandlers } = useOrder();

  const onConfirmClick = () => {
    setConfirmDialog(true);
  };

  const confirm = () => {
    orderHandlers.confirm(orderId, { enableSnackbar: true });
    setConfirmDialog(false);
  };

  const onResendClick = () => {
    setResendEmailDialog(true);
  };

  const resendEmail = () => {
    const event = 'order-resend-confirmation';
    orderHandlers.events(orderId, event, { enableSnackbar: true });
    setResendEmailDialog(false);
  };
  return (
    <Fragment>
      {isOrderUnconfirmed({ status: orderStatus }) ? (
        <Fragment>
          <Container>
            <ButtonConfirmed onClick={onConfirmClick} variant="outlined">
              MARK AS CONFIRMED
            </ButtonConfirmed>
            <OrderStatus>
              <IconAlert />
              <Text>{orderStatus === AWAITING ? 'Awaiting' : 'Open'}</Text>
            </OrderStatus>
          </Container>
          <SweetAlert
            cancelBtnCssClass={`${classes.button} ${classes.success}`}
            cancelBtnText="Close"
            confirmBtnCssClass={`${classes.button} ${classes.danger}`}
            confirmBtnText="Yes, confirm it!"
            onCancel={() => setConfirmDialog(false)}
            onConfirm={confirm}
            show={confirmDialog}
            showCancel
            style={{ marginTop: '-200px' }}
            title="Are you sure?"
            warning
          >
            You will not be able to recover this change!
          </SweetAlert>
        </Fragment>
      ) : (
        <Fragment>
          <Container>
            <ButtonConfirmed onClick={onResendClick} variant="outlined">
              Resend confirmation email
            </ButtonConfirmed>
          </Container>
          <SweetAlert
            cancelBtnCssClass={`${classes.button} ${classes.success}`}
            cancelBtnText="Close"
            confirmBtnCssClass={`${classes.button} ${classes.danger}`}
            confirmBtnText="Yes, send it!"
            onCancel={() => setResendEmailDialog(false)}
            onConfirm={resendEmail}
            show={resendEmailDialog}
            showCancel
            title="Are you sure?"
            warning
          >
            You will resend the confirmation email to the client!
          </SweetAlert>
          <SweetAlert
            confirmBtnCssClass={`${classes.button} ${classes.success}`}
            onConfirm={orderHandlers.resetEvents}
            show={events.data}
            success
            title="Good job!"
          >
            The email was send successfully!
          </SweetAlert>
        </Fragment>
      )}
    </Fragment>
  );
}

TopContainer.propTypes = {
  orderId    : PropTypes.string,
  orderStatus: PropTypes.string,
  classes    : PropTypes.shape({
    button : PropTypes.string,
    danger : PropTypes.string,
    success: PropTypes.string,
  }).isRequired,
  services: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
  })).isRequired,
};

TopContainer.defaultProps = {
  orderId    : '',
  orderStatus: AWAITING,
};

export default withStyles(sweetAlertStyle)(TopContainer);
